import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchWrapper } from '../_helpers';


// create slice

const name = 'warehouse';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState,reducers, extraReducers });

// exports

export const warehouseActions = { ...slice.actions, ...extraActions };
export const warehouseReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        
        warehouse: {},
      warehouseList: [],
        error: null,
        isLoading:false,
        warehouseResponse:{},
        deleteWarehouseResponse:[]
    }
}
function createReducers() {
    return {
        clearWarehouseResponse
    };

    function clearWarehouseResponse(state) {
        state.warehouseResponse = [];
        state.deleteWarehouseResponse= [];
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/Warehouse`;
    return {
        getWarehouseDetails: GetWarehouseDetails(),
        saveWarehouse:saveWarehouse(),
      getWarehouseById :getWarehouseById(),
      deleteWarehouse : deleteWarehouse(),
      
      
    };

    function GetWarehouseDetails() {
        return createAsyncThunk(
            `${name}/GetWarehouseDetails`,
            async () => await fetchWrapper.get(`${baseUrl}/GetWarehouseDetails`)
        );

       
    }
    function getWarehouseById() {
        return createAsyncThunk(
            `${name}/getWarehouseById`,
             async (WarehouseDetail) => await fetchWrapper.get(`${baseUrl}/GetWarehouseDetails?WarehouseID=${WarehouseDetail.WareHouseID}`)
        );
    }
    function saveWarehouse() {
        return createAsyncThunk(
            `${name}/saveWarehouse`,
            async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateWarehouse`, addFormData )
        );
    }
     function deleteWarehouse()
    {
        return createAsyncThunk(
            `${name}/deleteWarehouse`,
             async (WarehouseDetail) => await fetchWrapper.post(`${baseUrl}/DeleteWarehouse?WarehouseID=${WarehouseDetail.WarehouseID}&DeletedBy=${WarehouseDetail.DeletedBy}`)
        );
    }
}

function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getWarehouseDetails.pending, (state) => {  //getWarehouseDetails
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getWarehouseDetails.fulfilled, (state, action) => {
            state.isLoading = true;
            state.warehouseResponse = [];
            state.deleteWarehouseResponse = [];
            state.warehouseList = action.payload || [];
        })
        .addCase(extraActions.getWarehouseDetails.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getWarehouseById.pending, (state) => {  //getWarehouseById
            state.warehouse = { loading: true };
        })
        .addCase(extraActions.getWarehouseById.fulfilled, (state, action) => {
            state.warehouse = action.payload && action.payload[0];
            state.warehouseResponse = [];
            state.deleteWarehouseResponse = [];
        })
        .addCase(extraActions.getWarehouseById.rejected, (state, action) => {
            state.warehouse = { error: action.error };
        })
        .addCase(extraActions.saveWarehouse.pending, (state) => {  //saveWarehouse
            state.warehouseResponse = { loading: true };
        })
        .addCase(extraActions.saveWarehouse.fulfilled, (state, action) => {
            state.warehouseResponse = action.payload;
            state.deleteWarehouseResponse = [];
        })
        .addCase(extraActions.saveWarehouse.rejected, (state, action) => {
            state.warehouseResponse = { error: action.error };
        })
        .addCase(extraActions.deleteWarehouse.pending, (state) => { //deleteWarehouse
            state.deleteWarehouseResponse = { loading: true };
        })
        .addCase(extraActions.deleteWarehouse.fulfilled, (state, action) => {
            state.deleteWarehouseResponse = action.payload;
            state.warehouseResponse = [];
        })
        .addCase(extraActions.deleteWarehouse.rejected, (state, action) => {
            state.deleteWarehouseResponse = { error: action.error };
        });
}
